<template>
    <div class="contents">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Orders Shop
                                </h4>
                            </div>
                        </div>
                        <div class="action-btn">
                            <router-link :to="`/shop`" class="btn px-15 btn-secondary text-white">
                                <i class="fas fa-arrow-left fs-16"></i>
                                Kembali
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <OrderTable :shop-id="shopId" @view-detail="viewOrderDetail" />
                    </div>
                </div>
            </div>
            <modal name="order_detail" :height="'auto'" :adaptive="true" :scrollable="true">
                <div style="margin: 20px">
                    <OrderDetailModal :order-id="selectedOrderId" @close="closeModal" @updated="refreshTable" />
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
    import OrderTable from "@/components/tables/ShopOrder.vue";
    import OrderDetailModal from "@/components/modals/shop/OrderDetailModal.vue";

    export default {
        components: {
            OrderTable,
            OrderDetailModal,
        },
        data() {
            return {
                shopId: null,
                selectedOrderId: null
            };
        },
        mounted() {
            this.shopId = parseInt(this.$route.params.shopId);
        },
        methods: {
            viewOrderDetail(orderId) {
                this.selectedOrderId = orderId;
                this.$modal.show('order_detail');
            },
            closeModal() {
                this.$modal.hide('order_detail');
            },
            refreshTable() {
                this.$root.$emit('refresh-order-table');
            }
        },
    };
</script>

